// extracted by mini-css-extract-plugin
export default {"scrollButton":"Layout_scrollButton__zFWld","bounce":"Layout_bounce__pF8iO"};